var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container redirect-shell"},[_c('el-result',{attrs:{"icon":"info","title":"AI 配置已并入评估报告配置","subTitle":"系统会自动带你前往新的统一配置页。"}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goToNewPage}},[_vm._v("立即前往")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }